import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { Accordion, AccordionSummary, Grid } from "@material-ui/core";

import Loader from "../../common/Loader/Loader";
import CustomAlert from "../../common/CustomAlert/CustomAlert";

import slotsInformationStyles from "../SlotsInformation/SlotsInformationStyles";

import { PosStatusToggle } from "../../POSList/posUtils/PosAccessUtils";
import { activateOrDeactivateAServiceOfPOS } from "../redux/completeSetupSlice";
import { selectServiceTypes } from "../../../config/redux/configurationsSlice";
import { ALERT_TYPES, STATUS_OK } from "../../../config/constants";
import { is_fbc_service_toggle_visible } from "../CompleteSetupUtils";
import { isEmptyOrNull } from "../../../utils/DataUtils";

const FBCInformation = (props) => {
  const { posNo, userInfo, serviceTypeName, serviceTypeId, slotsInformation } =
    props;

  const classes = slotsInformationStyles();
  const dispatch = useDispatch();

  const serviceTypes = useSelector(selectServiceTypes);

  const handleServiceActiveInactiveSwitch = async (e) => {
    const { checked } = e.target;
    const payloadRequest = {
      posNo,
      serviceType: serviceTypeId,
      serviceTypeName: serviceTypeName?.toUpperCase() ?? "",
      active: checked,
    };
    dispatch(activateOrDeactivateAServiceOfPOS(payloadRequest))
      .then((actionResult) => {
        const { statusCode, message: error } = actionResult?.payload || {};

        if (statusCode === STATUS_OK) {
          let message = checked
            ? `Service activated successfully`
            : `Service de-activated successfully`;
          CustomAlert(ALERT_TYPES.SUCCESS, message);
        } else if (error) {
          CustomAlert(ALERT_TYPES.ERROR, error);
        } else {
          CustomAlert(
            ALERT_TYPES.INFO,
            "Operation completed, but no specific status or error message was returned."
          );
        }
      })
      .catch((unhandledError) => {
        console.error(
          "Unhandled error during service activation/deactivation:",
          unhandledError
        );
        CustomAlert(
          ALERT_TYPES.ERROR,
          unhandledError?.message ??
          "An unexpected error occurred during the operation."
        );
      });
  };

  function renderServiceDisplayName() {
    if (!serviceTypes) {
      return <div className={classes.textCapitalize}>{serviceTypeName || "Unknown Service"}</div>;
    }
    const service = serviceTypes.find((s) => s?.name === serviceTypeName);
    const displayName = service?.displayName ?? "Unknown Service";
    return <div className={classes.textCapitalize}>{displayName}</div>;
  }

  return (
    <div className={classes.slotsInfoContainer}>
      {!isEmptyOrNull(slotsInformation?.loading) &&
        slotsInformation?.loading ? (
        <Loader />
      ) : (
        <Accordion className={classes.activeAccordion} expanded={false}>
          <AccordionSummary
            expandIcon={null}
            className={`${classes.accordionSummary} ${classes.serviceAccSummary}`}
          >
            <Grid container alignItems="center">
              <Grid item xs={4} className={classes.activeServiceType}>
                <div className={classes.textCapitalize}>
                  {renderServiceDisplayName()}
                </div>
              </Grid>
              <Grid item xs={2}>
                {" "}
              </Grid>

              <Grid item xs={6}>
                {is_fbc_service_toggle_visible(userInfo) ? (
                  <Grid container justifyContent="flex-end">
                    {!isEmptyOrNull(slotsInformation?.toggling) &&
                      slotsInformation.toggling ? (
                      <Grid item xs={5} className={classes.posRelative}>
                        <Loader />
                      </Grid>
                    ) : (
                      <PosStatusToggle
                        classes={classes}
                        userInfo={userInfo}
                        checked={Boolean(slotsInformation?.active)}
                        handleServiceActiveInactiveSwitch={(e) =>
                          handleServiceActiveInactiveSwitch(e)
                        }
                        disabled={slotsInformation?.toggling}
                      />
                    )}
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </AccordionSummary>
        </Accordion>
      )}
    </div>
  );
};

FBCInformation.propTypes = {
  posNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  userInfo: PropTypes.object.isRequired,
  serviceTypeName: PropTypes.string.isRequired,
  serviceTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  slotsInformation: PropTypes.object,
};

export default React.memo(FBCInformation);
